import { rgba } from 'polished';
import { mapValues } from 'radash';
import '../tokens/border-radiuses.js';
import { colors } from '../tokens/colors.js';
import '../tokens/font-sizes.js';
import '../tokens/gaps.js';
import '../tokens/heights.js';
import { opacities } from '../tokens/opacities.js';
import '../tokens/spacings.js';
import '../tokens/widths.js';

/**
 * Collection of alias tokens for text colors. Designed to ensure uniformity in typography. Gray is
 * adjusted to serve as a versatile neutral tone.
 */ const textColorAliases = {
    light: {
        ...mapValues(colors, (color)=>({
                none: 'transparent',
                weak: rgba(color[600], opacities.medium),
                medium: color[600],
                strong: color[700]
            })),
        gray: {
            none: 'transparent',
            weak: rgba('black', opacities.weaker),
            medium: rgba('black', opacities.strong),
            strong: 'black'
        }
    },
    dark: {
        ...mapValues(colors, (color)=>({
                none: 'transparent',
                weak: rgba(color[400], opacities.strong),
                medium: color[300],
                strong: color[200]
            })),
        gray: {
            none: 'transparent',
            weak: rgba('white', opacities.medium),
            medium: rgba('white', opacities.stronger),
            strong: 'white'
        }
    }
};

export { textColorAliases };
//# sourceMappingURL=text-colors.js.map
